const messages = {
  title: "Ceníky a produktové brožury",
  title_media: "Ceníky a produktové brožury",
  description:
    "Zde si stáhněte nejnovější brožury a letáky o našich pneumatikách Bridgestone a Firestone pro osobní automobily, SUV a užitková vozidla.",
  short_description:
    "Zde najdete materiály pro sociální sítě, in-store TV a další.",
  mediaCategories: {
    products: "Produkty",
    brand_and_solutions: "Značka a řešení",
    season_and_promotions: "Sezóna a akce",
    format: "Formát",
    cars_and_vans: "Auto, SUV, Utility",
    truck_and_buses: "Těžká nákladní vozidla a autobusy",
    motorcycle: "Motocykl",
    agriculture: "Zemědělství",
    construction_machinery: "Stavební stroje",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiály",
    brochures: "Produktové brožury",
    price_list: "Ceníky",
    materials: "Materiály",
    video_in_store: "Video s titulky",
    video_online: "Video bez titulků",
    video: "Video",
    banner_website: "Prapor",
    banner_social_media: "Sociální sítě",
    logos: "Loga",
    summer: "Letní",
    winter: "Zima",
    all_season: "Všechna roční období",
    promotions: "Akce",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIATÉKA",
    description:
      "Vítejte v sekci médií věnované   \n" +
      "produktům Bridgestone a Firestone.  \n <br> <br>" +
      "Objevíte vizuály produktů,   \n" +
      "logotypy a také široký výběr   \n" +
      "bannerů, videí a digitálních materiálů   \n" +
      "k použití na vašich webových stránkách nebo na   \n" +
      "sociálních sítích.  ",
    bDrive: {
      title: "Fotografie produktů",
      description:
        "Aktuální obrázky   \n" +
        "lze stáhnout   \n" +
        "z našeho portálu B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "OBJEVIT",
  },
  searchMedia: "Zadejte klíčové slovo",
  searchResults: "Výsledky hledání",
};

export default {
  messages,
};
